<div class="relative flex flex-col w-full h-full">

    <!-- Dismiss button -->
    <ng-container *ngIf="processState!== 'Results'">
        <div class="absolute top-0 right-0 pt-4 pr-4">
            <button
                mat-icon-button
                (click)="cancelProcess()">
                <mat-icon
                    class="text-secondary"
                    [svgIcon]="'heroicons_outline:x'"></mat-icon>
            </button>
        </div>
    </ng-container>
    <!-- Content -->
    <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">
        <!-- Icon -->
        <div
            class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600">
            <mat-icon
                class="text-current">
                subtitles
            </mat-icon>
        </div>


        <ng-container>
            <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left w-full">

                <!-- Title -->
                <ng-container *ngIf="processState">
                    <div
                        class="text-xl leading-6 font-medium">{{processState}}</div>
                </ng-container>

                <!-- Message -->
                <ng-container *ngIf="processingMessage">
                    <div
                        class="text-secondary"
                        [innerHTML]="processingMessage">

                    </div>
                </ng-container>
                <mat-progress-bar mode="determinate" value="{{completeProgress}}"></mat-progress-bar>

            </div>

        </ng-container>

    </div>

    <!-- Actions -->
    <ng-container>
        <div class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">

            <!-- Cancel -->
            <ng-container *ngIf="processState!== 'Results'">
                <button mat-stroked-button (click)="cancelProcess()">
                    Cancel
                </button>
            </ng-container>

            <!-- Confirm -->
            <ng-container *ngIf="processState!== 'Processing' && processState !== 'Discovering Files...'">
                <button
                    mat-flat-button
                    color="primary"
                    (click)="confirm()">
                    Confirm
                </button>
            </ng-container>

        </div>
    </ng-container>

</div>
